import React from 'react';

import { TableCell } from '@material-ui/core';
import PropTypes from 'prop-types';

import { booleanToYesOrHyphen } from 'utils/DataUtils';

export const CustomTableCell = ({ children, ...props }) => {
  const getTableCellContent = () => {
    if (!children) return '-';
    if (typeof children === 'boolean') return booleanToYesOrHyphen(children);
    return children;
  };
  return <TableCell {...props}>{getTableCellContent()}</TableCell>;
};
CustomTableCell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.bool,
    PropTypes.number,
  ]),
};

CustomTableCell.defaultProps = {
  children: '',
};
